module.exports = __webpack_public_path__ + "img/logo-ayuda.e1e71f17.svg";